import React from "react";
import "./TcModal.scss";
import Button from "../../button/Button";
import moment from "moment";
interface TcModalProps {
  onClose: () => void;
  onAgree: () => void;
  data: any;
}
const TcModal: React.FC<TcModalProps> = ({ onAgree, onClose, data }) => {
  const date = moment(data.ApprovalDate).format("DD/MM/yyyy");
  return (
    <div className='modal'>
      <div className='modal-content'>
        <div className='md-header'>
          <div className='md-agreement'>AGREEMENT</div>
          <div className='md-text'>Terms of Service</div>
          <div className='md-sub-txt'>Last updated on {date}</div>
        </div>
        <div
          className='md-cont'
          dangerouslySetInnerHTML={{ __html: data.HTMLContent }}
        />
        <div className='md-btn-cont'>
          <Button text='Accept & Continue' isPrimary onClick={onAgree} />
        </div>
      </div>
    </div>
  );
};
export default TcModal;
